export class CsString {
  public static empty: string = '';

  public static join(separator: string, str: string[]) {
    return str.join(separator);
  }

  public static isNullOrEmpty(str: string) {
    return !str || str === CsString.empty;
  }

  public static isNullOrWhiteSpace(str: string) {
    return !str || str.trim() === CsString.empty;
  }
}
